<template>
    <div :class="{'form-checkbox--disabled': disabled}" class="form-checkbox">
        <input :disabled="disabled"
               :id="term.slug"
               :name="term.taxonomy + '[]'"
               :value="term.slug"
               @change="$emit('checked', { value: term.slug, name: term.taxonomy, state: checkedState})"
               type="checkbox"
               v-model="checkedState">
        <label :for="term.slug">{{ term.name }}</label>
    </div>

</template>

<script>
    import {EventBus} from "../event-bus";

    export default {
        name: "Checkbox",
        props: ['term', 'checked'],
        data() {
            return {
                checkedState: this.checked ?? false,
                disabled: false
            }
        },
        methods: {
            unCheck() {
                this.checkedState = false
            }
        },
        mounted() {
            EventBus.$on('clear-filters', this.unCheck)
        }
    }
</script>

<style scoped>

</style>
